import { ModalMsgQuestionComponent } from './../app-components/modal-msg-question/modal-msg-question.component';
import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalMsgComponent } from '../app-components/modal-msg/modal-msg.component';
import { ModalJustificativaComponent } from '../app-components/modal-justificativa/modal-justificativa.component';


@Injectable({
  providedIn: 'root'
})
export class ModalMsgService {

  constructor(private modalService: NgbModal) { }

  private modalRef: any;

  open(title: string, text = '', type = 'info', 
  beforeDismiss = null, 
  cancelOptions:{ text?: string, btnClass?: string,  hidden?: boolean } = null, 
  okOptions:{ text?: string, btnClass?: string,  hidden?: boolean } = null, 
  html = false, windowClass?): Promise<any> {
    okOptions = {
      text: 'Confirmar',
      btnClass: 'btn-success',
      hidden: false,
      ...okOptions
    },
      cancelOptions = {
        text: 'Cancelar',
        btnClass: 'btn-secondary',
        hidden: false,
        ...cancelOptions,
      },

      this.modalRef = this.modalService.open(ModalMsgComponent, {
        centered: true,
        beforeDismiss: beforeDismiss,
        windowClass: windowClass
      });

    this.modalRef.componentInstance.ok = okOptions;
    this.modalRef.componentInstance.cancel = cancelOptions;
    this.modalRef.componentInstance.title = title;
    this.modalRef.componentInstance.text = text;
    this.modalRef.componentInstance.html = html;
    this.modalRef.componentInstance.type = type;
    return this.modalRef.result;
  }

  close() {
    this.modalRef.close('close');
  }

  openDialog(title: string, text = '', type = 'info', beforeDismiss = null) {
    return this.open(title, text, type, beforeDismiss,
      { text: 'Fechar', btnClass: 'btn-secondary' },
      { hidden: true }
    );
  }

  openDialogQuestion(title: string, text = '', type = 'warning', beforeDismiss = null) {
    return this.open(title, text, type, beforeDismiss,
      { text: 'Não' },
      { text: 'Sim' }
    );
  }
  async justificativa(titulo:string = 'Informe uma justificativa para a operação') {
    const modalRef = this.modalService.open(ModalJustificativaComponent, { centered: true });
    modalRef.componentInstance.cabecalho = titulo;
    try {
      let justificativa = await modalRef.result;
      if (justificativa) { 
        return justificativa;
      } else {
        throw "justificativa não informada";
      }
    } catch (error) {
      await this.openDialog('Erro ao efetuar operação', 'Justificativa não informada', 'danger');
      throw "justificativa não informada";
    }
  }


}
